(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparativo"] && !Shopify.designMode) return;
  try {
    
  class ComparativoPrecos extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-cmp-mode]').forEach((btn) => {
        btn.addEventListener('click', () => this.pick(btn.dataset.cmpMode));
      });
    }

    pick(mode) {
      const card = document.querySelector('subscription-card');
      const target = card || document.querySelector('form[action*="/cart/add"]');
      if (card && typeof card.setMode === 'function') card.setMode(mode);
      if (!target) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
    }
  }

  customElements.define('comparativo-precos', ComparativoPrecos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-suplemind"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRotor(el) {
      if (el.dataset.rotorInit) return;
      el.dataset.rotorInit = '1';
      var words = (el.dataset.rotor || '')
        .split(',')
        .map(function (w) { return w.trim(); })
        .filter(Boolean);
      if (words.length < 2) return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var i = 0;

      setInterval(function () {
        i = (i + 1) % words.length;
        if (reduce) {
          el.textContent = words[i];
          return;
        }
        el.style.transition = 'opacity .42s cubic-bezier(.2,.8,.2,1), transform .42s cubic-bezier(.2,.8,.2,1)';
        el.style.opacity = '0';
        el.style.transform = 'translateY(8px)';
        setTimeout(function () {
          el.textContent = words[i];
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }, 420);
      }, 2400);
    }

    function run() {
      document.querySelectorAll('.smind-hero .rotor[data-rotor]').forEach(initRotor);
    }

    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kits-suplemind"] && !Shopify.designMode) return;
  try {
    
  class KitCollection extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-kit-grid]');
      this.filters = Array.from(this.querySelectorAll('[data-kit-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-cat]'));
      this.prev = this.querySelector('[data-kit-prev]');
      this.next = this.querySelector('[data-kit-next]');

      this.filters.forEach((btn) => {
        btn.addEventListener('click', () => this.applyFilter(btn.dataset.kitFilter, btn));
      });
      if (this.prev) this.prev.addEventListener('click', () => this.nav(-1));
      if (this.next) this.next.addEventListener('click', () => this.nav(1));
      if (this.grid) this.grid.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });

      this.updateArrows();
    }

    applyFilter(cat, btn) {
      this.filters.forEach((b) => {
        const on = b === btn;
        b.classList.toggle('active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.cards.forEach((card) => {
        card.hidden = !(cat === 'todos' || card.dataset.cat === cat);
      });
      if (this.grid) this.grid.scrollTo({ left: 0 });
      this.updateArrows();
    }

    nav(dir) {
      if (!this.grid) return;
      const card = this.grid.querySelector('[data-cat]:not([hidden])');
      const amount = card ? card.offsetWidth + 24 : 320;
      this.grid.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.grid) return;
      const overflow = this.grid.scrollWidth > this.grid.clientWidth + 4;
      this.classList.toggle('is-static', !overflow);
      if (!this.prev || !this.next) return;
      const max = this.grid.scrollWidth - this.grid.clientWidth - 2;
      this.prev.disabled = !(overflow && this.grid.scrollLeft > 2);
      this.next.disabled = !(overflow && this.grid.scrollLeft < max);
    }
  }

  if (!customElements.get('kit-collection')) {
    customElements.define('kit-collection', KitCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prova-social"] && !Shopify.designMode) return;
  try {
    
  class ProvaSocialStats extends HTMLElement {
    connectedCallback() {
      this.nums = this.querySelectorAll('[data-counter]');
      if (!this.nums.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.nums.forEach((el) => {
        el.dataset.final = el.textContent;
      });

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.animate(entry.target);
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.4 }
      );

      this.nums.forEach((el) => io.observe(el));
    }

    format(value, fmt) {
      if (fmt === 'percent') return Math.round(value) + '%';
      if (fmt === 'dias') return Math.round(value) + ' dias';
      if (fmt === 'plus_k') return '+' + Math.round(value / 1000) + 'k';
      if (fmt === 'star') return value.toFixed(1) + '★';
      return Math.round(value).toLocaleString('pt-BR');
    }

    animate(el) {
      const target = parseFloat(el.dataset.counter);
      const fmt = el.dataset.format || '';
      const final = el.dataset.final;
      if (isNaN(target)) return;

      const duration = 1400;
      const start = performance.now();
      const tick = (now) => {
        const progress = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = this.format(target * eased, fmt);
        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          el.textContent = final;
        }
      };

      el.textContent = this.format(0, fmt);
      requestAnimationFrame(tick);
    }
  }

  customElements.get('prova-social-stats') ||
    customElements.define('prova-social-stats', ProvaSocialStats);

  } catch(e) { console.error(e); }
})();
})();
